import React from 'react';
import {
  IconBuilding,
  IconPackage,
  IconShield,
  IconSmartphone,
  type IconProps,
} from '../components/icons';

export interface FAQEntry {
  question: string;
  answer: string;
  tags?: string[];
}

export interface FAQSection {
  id: number;
  title: string;
  icon: React.FC<IconProps>;
  questions: FAQEntry[];
}

export const FAQ_SECTIONS: FAQSection[] = [
  {
    id: 0,
    title: '产品与体验',
    icon: IconPackage,
    questions: [
      {
        question: '三米云有哪些自研产品？',
        answer: '我们目前有五款自研产品：ToC 侧包括蛐蛐 QuQu（关系管家）、薪资奖励官（实时计薪）、订无忧（订阅管理，升级中）；ToB 侧包括销售智能体与排名小程序（谁是黑马）。每款产品独立品牌、独立场景。',
        tags: ['产品矩阵', 'QuQu', '薪资奖励官'],
      },
      {
        question: '如何下载或体验 ToC 产品？',
        answer: '薪资奖励官已在 App Store 上架，可在产品页直接跳转下载。蛐蛐 QuQu 提供详情页与功能介绍，欢迎通过联系页面获取最新体验方式。订无忧处于产品升级阶段，请关注动态页获取进展。',
        tags: ['下载', 'App Store', 'ToC'],
      },
      {
        question: '销售智能体与排名小程序如何合作？',
        answer: '两款 ToB 产品支持 SaaS 合作与定制集成，适用于本地企业的销售跟进、团队激励与排名竞赛场景。请通过联系页面选择「商务合作」，我们会安排产品演示与方案沟通。',
        tags: ['ToB', '销售智能体', '合作'],
      },
    ],
  },
  {
    id: 1,
    title: '账号与隐私',
    icon: IconShield,
    questions: [
      {
        question: '我的数据如何被使用？',
        answer: '我们遵循最小必要原则收集数据，仅用于提供产品功能与改进体验。详细说明请参阅隐私政策页面，包括信息收集范围、使用方式与用户权利。',
        tags: ['隐私', '数据安全'],
      },
      {
        question: '如何删除账号或导出数据？',
        answer: '您可在 App 内设置中申请账号注销，或通过 service@bestsmy.com 提交数据导出或删除请求。我们会在法定时限内处理并完成确认。',
        tags: ['账号', '数据导出'],
      },
    ],
  },
  {
    id: 2,
    title: '企业与商务',
    icon: IconBuilding,
    questions: [
      {
        question: '如何发起商务合作？',
        answer: '访问联系页面填写咨询表单，或直接发送邮件至 service@bestsmy.com。请在主题中说明合作类型（产品演示、定制集成、渠道合作等），我们会在 24 小时内回复。',
        tags: ['商务合作', '联系'],
      },
      {
        question: '是否支持定制开发？',
        answer: '我们优先推进自研产品迭代。对于与销售智能体、排名小程序相关的场景化集成与本地化部署，可评估定制方案。具体范围与周期将在初步沟通后给出建议。',
        tags: ['定制', 'ToB'],
      },
    ],
  },
  {
    id: 3,
    title: '技术支持',
    icon: IconSmartphone,
    questions: [
      {
        question: '遇到问题如何反馈？',
        answer: '产品 Bug 或功能建议可通过联系页面选择「问题反馈」提交，邮件中请附上设备型号、系统版本与问题描述。紧急问题可在邮件标题注明「紧急」。',
        tags: ['反馈', 'Bug', '支持'],
      },
      {
        question: '支持哪些平台？',
        answer: 'ToC 产品主要面向 iOS（含 Apple Watch 联动场景）。ToB 产品以微信小程序与企业 SaaS 形式交付为主，具体以各产品详情页说明为准。',
        tags: ['iOS', '小程序', '平台'],
      },
    ],
  },
];
